import * as  Procedural from './Procedural';
import * as  Procedural_Caching from './Procedural_Caching';
import * as  Procedural_Premium from './Procedural_Premium';
import * as  Simple from './Simple';
import * as  Inheritance from './Inheritance';
import * as  Inheritance_Problem_01 from './Inheritance_Problem_01';
import * as  Inheritance_Problem_02 from './Inheritance_Problem_02';
import * as  Inheritance_Problem_03 from './Inheritance_Problem_03';
import * as  Inheritance_Problem_Error_Rigid from './Inheritance_Problem_Error_Rigid';
import * as  Inheritance_Problem_Error_Forced from './Inheritance_Problem_Error_Forced';
import * as  Strategy_Pure from './Strategy_Pure';
import * as  Strategy_Inheriting from './Strategy_Inheriting';

export type Example = {
	class: RobotInterface,
	init?: () => RobotInterface,
};

export type ExamplesType = {
	[key: string]: Example,
}

export interface RobotInterface {
	getMessage(): string;
	avatar: string;
	name: string;
}

interface Examples {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any,
}

const Examples: Examples = {
	Procedural,
	Procedural_Caching,
	Procedural_Premium,
	Simple,
	Inheritance,
	Inheritance_Problem_01,
	Inheritance_Problem_02,
	Inheritance_Problem_03,
	Inheritance_Problem_Error_Rigid,
	Inheritance_Problem_Error_Forced,
	Strategy_Pure,
	Strategy_Inheriting,
};

export const getExamples = (group: string): ExamplesType => {
	const examples = Examples[group];
	if (!examples) {
		throw new Error(`No examples found for group ${group}`);
	}

	if (!examples.default) {
		throw new Error(`No examples have been exported from ${group}`);
	}

	return examples.default;
}

export const getExample = (group: string, slug: string): Example => {
	const Example = getExamples(group);

	if (!Example) {
		throw new Error(`Example "${group}" not found`);
	}

	const Robot = Example[slug];
	if (!Robot) {
		throw new Error(`Robot "${slug}" not found in "${group}"`);
	}

	return Robot;
}

export const getRobot = (example: string, slug: string): RobotInterface => {
	const Robot = getExample(example, slug);
	if (!Robot.init) {
		throw new Error(`Robot "${slug}" in "${example}" has no init function`);
	}
	try {
		return Robot.init() as RobotInterface;
	} catch (e) {
		throw new Error(`Cannot instantiate Robot "${slug}" from "${example}"`);
	}
}